import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import ScheduleDurationList from "./ScheduleDurationList.vue";
import { computed } from "vue";
import { convertMillisToIsoDuration } from "src/shared/v-components/campaign-component-variable/input/schedule/schedule-duration-service";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ScheduleListComopnentVariableRawValue',
    props: {
        modelValue: {}
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const isDelayList = (value) => {
            return (Array.isArray(value) && value.every((item) => typeof item === "string"));
        };
        const valueProxy = computed({
            get() {
                return isDelayList(props.modelValue) ? props.modelValue : [];
            },
            set(value) {
                const isoDurations = value
                    .map((element) => {
                    if (typeof element === "string") {
                        return element;
                    }
                    return convertMillisToIsoDuration(element);
                })
                    .filter((value) => value !== null);
                emit("update:modelValue", isoDurations);
            },
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(ScheduleDurationList, {
                    scheduleList: valueProxy.value,
                    "onUpdate:scheduleList": _cache[0] || (_cache[0] = ($event) => ((valueProxy).value = $event))
                }, null, 8 /* PROPS */, ["scheduleList"])
            ]));
        };
    }
});
